import React from 'react';
import style from './style.module.less';
import { map } from 'lodash';
import { Link } from 'react-router';
import classNames from 'classnames';

const links = [
    {
        title: 'Die Golden City Auskunft',
        to: '/',
        image: require('./kontakt.png'),
    },
    {
        title: 'Die Golden City Projekte',
        to: '/projekte/',
        image: require('./projekte.png'),
    },
    {
        title: 'Das Golden City Programm',
        to: '/programm/',
        image: require('./programm.png'),
    },
];

function Menu({ route }) {
    return (
        <nav className={style.container}>
            <ul className={style.list}>
                {map(links, (link, idx) => {
                    const isActive = link.to === '/' ? route === '/' : !route.indexOf(link.to);

                    return (
                        <li className={style.item} key={idx}>
                            <Link to={link.to} className={classNames(style.link, { [style.link_active]: isActive })}>
                                <img alt={link.title} src={link.image} className={style.image} />
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export default Menu;



// WEBPACK FOOTER //
// ../components/Menu/index.js